import {
  Lock as LockIcon,
  Person as PersonIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import {
  Alert,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import perfilService from "../services/perfil";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`perfil-tabpanel-${index}`}
      aria-labelledby={`perfil-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 2, sm: 3 } }}>{children}</Box>}
    </div>
  );
}

function Perfil() {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [perfilData, setPerfilData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    username: "",
  });
  const [senhaData, setSenhaData] = useState({
    senha_atual: "",
    nova_senha: "",
    confirmar_senha: "",
  });

  useEffect(() => {
    carregarPerfil();
  }, []);

  const carregarPerfil = async () => {
    try {
      const data = await perfilService.obterPerfil();
      setPerfilData(data);
    } catch (err) {
      setError("Erro ao carregar dados do perfil");
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setError("");
    setSuccess("");
  };

  const handlePerfilChange = (e) => {
    const { name, value } = e.target;
    setPerfilData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSenhaChange = (e) => {
    const { name, value } = e.target;
    setSenhaData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePerfilSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await perfilService.atualizarPerfil(perfilData);
      setSuccess("Perfil atualizado com sucesso!");
    } catch (err) {
      setError(err.detail || "Erro ao atualizar perfil");
    } finally {
      setLoading(false);
    }
  };

  const handleSenhaSubmit = async (e) => {
    e.preventDefault();
    if (senhaData.nova_senha !== senhaData.confirmar_senha) {
      setError("As senhas não conferem");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await perfilService.alterarSenha(senhaData);
      setSenhaData({
        senha_atual: "",
        nova_senha: "",
        confirmar_senha: "",
      });
      setSuccess("Senha alterada com sucesso!");
    } catch (err) {
      setError(err.detail || "Erro ao alterar senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mt: { xs: 2, sm: 4 }, mb: { xs: 2, sm: 4 } }}>
        <Paper
          elevation={0}
          sx={{
            p: 0,
            borderRadius: 2,
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Cabeçalho do Perfil */}
          <Box
            sx={{
              p: { xs: 2, sm: 3 },
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.dark} 90%)`,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              color: "white",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "center", sm: "center" },
              textAlign: { xs: "center", sm: "left" },
              gap: 2,
            }}
          >
            <Avatar
              sx={{
                width: { xs: 56, sm: 60 },
                height: { xs: 56, sm: 60 },
                bgcolor: "background.paper",
                color: theme.palette.primary.main,
              }}
            >
              <PersonIcon sx={{ fontSize: { xs: 36, sm: 40 } }} />
            </Avatar>
            <Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{ fontWeight: 600, fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
              >
                Meu Perfil
              </Typography>
              <Typography variant="body2">
                Gerencie suas informações pessoais
              </Typography>
            </Box>
          </Box>

          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <Tab
              id="perfil-tab-0"
              aria-controls="perfil-tabpanel-0"
              icon={<PersonIcon />}
              label="Dados Pessoais"
              iconPosition="start"
            />
            <Tab
              id="perfil-tab-1"
              aria-controls="perfil-tabpanel-1"
              icon={<LockIcon />}
              label="Alterar Senha"
              iconPosition="start"
            />
          </Tabs>

          {/* Mensagens de Erro/Sucesso */}
          <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            {success && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {success}
              </Alert>
            )}
          </Box>

          {/* Tab Dados Pessoais */}
          <TabPanel value={tabValue} index={0}>
            <form onSubmit={handlePerfilSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Nome"
                    name="first_name"
                    value={perfilData.first_name}
                    onChange={handlePerfilChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Sobrenome"
                    name="last_name"
                    value={perfilData.last_name}
                    onChange={handlePerfilChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={perfilData.email}
                    onChange={handlePerfilChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome de usuário"
                    name="username"
                    value={perfilData.username}
                    onChange={handlePerfilChange}
                  />
                </Grid>
              </Grid>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="flex-end"
                spacing={2}
                sx={{ mt: 3 }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  startIcon={<SaveIcon />}
                  fullWidth
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  {loading ? "Salvando..." : "Salvar Alterações"}
                </Button>
              </Stack>
            </form>
          </TabPanel>

          {/* Tab Alterar Senha */}
          <TabPanel value={tabValue} index={1}>
            <form onSubmit={handleSenhaSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Senha Atual"
                    name="senha_atual"
                    type="password"
                    value={senhaData.senha_atual}
                    onChange={handleSenhaChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nova Senha"
                    name="nova_senha"
                    type="password"
                    value={senhaData.nova_senha}
                    onChange={handleSenhaChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Confirmar Nova Senha"
                    name="confirmar_senha"
                    type="password"
                    value={senhaData.confirmar_senha}
                    onChange={handleSenhaChange}
                  />
                </Grid>
              </Grid>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="flex-end"
                spacing={2}
                sx={{ mt: 3 }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  startIcon={<LockIcon />}
                  fullWidth
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  {loading ? "Alterando..." : "Alterar Senha"}
                </Button>
              </Stack>
            </form>
          </TabPanel>
        </Paper>
      </Box>
    </Container>
  );
}

export default Perfil;
